import { render } from "./modou.vue?vue&type=template&id=0eb4632f&scoped=true"
import script from "./modou.vue?vue&type=script&lang=js"
export * from "./modou.vue?vue&type=script&lang=js"

import "./modou.vue?vue&type=style&index=0&id=0eb4632f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0eb4632f"

export default script